import { sidenav } from '../../styles/components/header/sidenav'

const SideNavFooter = ({ navigation }) => (
  <div className='footer-container'>
    <div className='footer-title'>Be the first to know</div>
    <div className='footer-subtitle'>Topics you care about, straight to your inbox</div>
    <a role='button' className='footer-button' href={navigation?.footer?.contacts?.Newsletter?.path || ''}>
      Explore Newsletters
    </a>
    <style jsx>{sidenav}</style>
  </div>
)

export default SideNavFooter
